import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Organization } from '../../entity/api/organization';
import { createBasicStoreState } from './basic-store';

type TModel = Organization;

/**
 * Organizations Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from organizations-queries.ts:
 * - useOrganizationsList()
 * - useOrganizationById(id)
 * - useUpdateOrganization()
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'organizations' }
  )
);
